import { css } from '@emotion/react'
import styled from '@emotion/styled'

const Footer = () => {
	return (
		<Wrapper>
			<ContactUS>
				문의·변경이 필요하면 <Phone>010-9768-2105</Phone>로 연락주세요.
			</ContactUS>
			<SaveButton type="submit">저장</SaveButton>
		</Wrapper>
	)
}

const Wrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	margin-top: 2rem;
`

const contactUsStyle = css`
	font-family: Pretendard;
	font-size: 1.4rem;
	font-style: normal;
	font-weight: 600;
	line-height: 2.1rem;
`

const ContactUS = styled.span`
	${contactUsStyle}
	color: #121212;
`

const Phone = styled.span`
	${contactUsStyle}
	color: #2F80ED;
`

const SaveButton = styled.button`
	border: none;
	border-radius: 1.1rem;
	background: #ffcf19;
	padding: 1rem 2.5rem;
	color: #121212;
	font-family: Pretendard;
	font-size: 1.6rem;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
	letter-spacing: 0.2px;
`

export default Footer
